import { Box } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { RoutesUrl } from "../../common/consts/Routes";
import { find, findAndUpdate, getData, store } from "../../services/service";
import CardComponent from "../shared/CardComponent";
import FormComponent, { FormData } from "../shared/test";
import { CardHeaderActions } from "../shared/CardHeaderActions";
import { getColumns } from "../../common/Utils/ActionUtils";

function NewClient() {
  let { id }: any = useParams();
  const { push } = useHistory();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState<FormData>({
    dynamicRows: [] as any,
  });
  const [clientNames, setClientNames] = useState<string[]>([""]);
  useEffect(() => {
    getData("clients").then((clients) => {
      if (clients.length > 0) {
        setClientNames(clients.map(el => el.name))
      }
    });
    if (id) {
      setIsLoading(true);
      find("parametrics", id)
        .then((val) => {
          if (!!!val?.dynamicRows) {
            val.dynamicRows = [];
          }
          setFormData(val);
        })
        .finally(() => setIsLoading(false));
    } else {
      setFormData({
        dynamicRows: [] as any,
      });
    }
  }, [id]);
  console.log(formData);

  // CSV Export functionality
  const componentRef = useRef(null);

  const csvColumns = [
    { name: "Проект", value: "project" },
    { name: "Платформа", value: "marketing-platform" },
    { name: "Описание на продукт/услуга", value: "product-description" },
    { name: "Език", value: "campaign-language" },
    { name: "Описание на посланията и целите на дигиталната реклама", value: "event" },
  ];

  const getCsvData = (data: FormData) => {
    const cleanData = { ...data };
    Object.keys(cleanData).forEach(key => {
      if (typeof cleanData[key] === "string") {
        cleanData[key] = cleanData[key].split("<br/>").join('\n');
      }
    });
    return [cleanData];
  }

  const renderHeaderActions = () => {
    // Check if form has any meaningful data
    const hasData = formData && Object.keys(formData).some(key => {
      const value = formData[key];
      if (key === 'dynamicRows') return false; // Ignore dynamicRows
      return value && value !== "";
    });

    if (!hasData) return null;

    const csvData = getCsvData(formData);
    const csvFileName = `parametrics_draft_${+new Date()}.csv`;

    return (
      <CardHeaderActions
        csvHeaders={getColumns(csvColumns)}
        csvFileName={csvFileName}
        csvData={csvData}
        componentRef={componentRef}
        hidePrintButton={true}
      />
    );
  }

  return (
    <Box>
      <CardComponent title={`New Parametrics`} isLoading={isLoading} headerActions={renderHeaderActions()}>
        <FormComponent
          staticFields={[
            {
              name: "project",
              label: "Име на проект",
              type: "text",
              required: true
            },
            // {
            //   name: "choose-client",
            //   label: "Клиент",
            //   type: "autocomplete",
            //   options: clientNames,
            //   required: true
            // },
            {
              name: "marketing-platform",
              label: "Платформа",
              type: "autocomplete",
              options: [
                "Facebook",
                
                "Instagram"
              ],
              required: true,
              validation: (v) => {
                if (!v) {
                  return "Полето е задължително!";
                }
              },
            },
            {
              name: "product-description",
              label: "Описание на продукт/услуга",
              type: "text",
              required: true,
              textFieldProps: {
                multiline: true,
                inputProps: {
                  maxLength: 200
                }
              }
            },
            {
              name: "campaign-language",
              label: "Език",
              type: "autocomplete",
              options: [
                "Български",
                "Английски"
               
              ],
              required: true,
            },
            // {
            //   name: "target-country",
            //   label: "Държава",
            //   type: "autocomplete",
            //   options: [
            //     "България",
            //     "САЩ",
            //     "Великобритания",
            //     "Германия"
            //   ],
            //   required: true,
            // },
            {
              name: "event",
              label: "Описание на посланията и целите на дигиталната реклама",
              type: "text",
              required: true,
              textFieldProps: {
                multiline: true,
                inputProps: {
                  maxLength: 500
                }
              }
            },
          ]}

          dynamicPlural="Лицa за контакт"
          dynamicSingle="Лице за контакт"
          onSubmit={async (data) => {
            try {
              if (id) {
                await findAndUpdate("parametrics", id, data);
                toast.success("Успешно редактиране");
                push(RoutesUrl.parametricsPro.list);
                return;
              }
              await store("parametrics", data);
              toast.success("Успешно добавяне");
              push(RoutesUrl.parametricsPro.list);
              return true;
            } catch (e) {
              toast.error("Нещо се обърка");
              console.error(e);
              return false;
            }
          }}
          editMode={id ? true : false}
          formData={formData}
          setFormData={setFormData}
        />
      </CardComponent>
    </Box>
  )
}

export default NewClient;